export function AvatarFillIcon() {
  return (
    <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" fill="none" viewBox="0 0 24 24">
      <path
        fill="currentColor"
        fillRule="evenodd"
        d="M2 12C2 6.477 6.477 2 12 2s10 4.477 10 10-4.477 10-10 10S2 17.523 2 12zm8 0a2 2 0 100-4 2 2 0 000 4zm3.253.34a1 1 0 011.494 0L18 16H7l1.4-1.867a2 2 0 013.2 0l.027.037 1.626-1.83z"
        clipRule="evenodd"
      ></path>
    </svg>
  );
}
